/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Script_TimingInputs */

const en_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script Timing`)
};

const fr_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing du script`)
};

const de_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skript-Timing`)
};

const it_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempistiche della sceneggiatura`)
};

const ru_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация сценария`)
};

const es_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización del guion`)
};

const zh_cn2_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚本时间安排`)
};

const ja_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプトのタイミング`)
};

const hi_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रिप्ट टाइमिंग`)
};

const pt_pt2_ad_section_script_timing = /** @type {(inputs: Ad_Section_Script_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronograma de Roteiro`)
};

/**
* | output |
* | --- |
* | "Script Timing" |
*
* @param {Ad_Section_Script_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_script_timing = /** @type {((inputs?: Ad_Section_Script_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Script_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_script_timing(inputs)
	if (locale === "de") return de_ad_section_script_timing(inputs)
	if (locale === "it") return it_ad_section_script_timing(inputs)
	if (locale === "ru") return ru_ad_section_script_timing(inputs)
	if (locale === "es") return es_ad_section_script_timing(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_script_timing(inputs)
	if (locale === "ja") return ja_ad_section_script_timing(inputs)
	if (locale === "hi") return hi_ad_section_script_timing(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_script_timing(inputs)
	return en_ad_section_script_timing(inputs)
});